import { clsx } from '@alexis/helpers/clsx';
import React from 'react';

import styles from '../styles/components/ProgressRing.module.scss';

interface ProgressRingProps {
  className?: string;
  progressPercentage: number;
  size: number;
  thickness: number;
}

const ProgressRing: React.FC<ProgressRingProps> = ({
  className,
  progressPercentage,
  size,
  thickness,
}) => {
  const middlePosition = size / 2;
  const radius = (size - thickness * 2) / 2;
  const circumference = radius * 2 * Math.PI;

  const offset = circumference - (progressPercentage / 100) * circumference;

  return (
    <svg
      className={clsx(styles.container, className)}
      style={{
        height: `${size / 16}rem`,
        width: `${size / 16}rem`,
        maxWidth: `${size}px`,
        maxHeight: `${size}px`,
      }}
    >
      <circle
        className={styles.backgroundCircle}
        cx={middlePosition}
        cy={middlePosition}
        r={radius}
        strokeWidth={thickness}
        strokeDasharray={`${circumference} ${circumference}`}
      />

      <circle
        className={styles.circle}
        cx={middlePosition}
        cy={middlePosition}
        r={radius}
        strokeWidth={thickness}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={offset}
      />
    </svg>
  );
};

export default ProgressRing;
